var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  d: "M17.997 9.015c.015 4.66-3.65 8.973-9.083 8.985C3.984 18.01.001 13.927 0 8.977 0 4.294 3.696-.027 9.051 0c5.274.027 8.975 4.3 8.946 9.015m-4.443 2.002c-.093-.067-.17-.125-.248-.178-1.044-.696-2.083-1.399-3.135-2.083-.222-.144-.314-.294-.311-.566.015-1.513.003-3.027.012-4.54 0-.239-.065-.326-.309-.315q-.547.029-1.095 0c-.275-.016-.34.087-.34.349q.016 2.738 0 5.475c0 .223.08.345.26.463 1.173.772 2.339 1.557 3.508 2.335.237.158.482.304.74.466z"
})));
export { SvgClockDark as ReactComponent };
export default __webpack_public_path__ + "static/media/clock-dark.b119badc.svg";